// extracted by mini-css-extract-plugin
export default {"myVideo":"Home_myVideo__hrO7c","content":"Home_content__zWRSk","homeBtn":"Home_homeBtn__ylIrJ"};